angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaAnniversaryDocumentsModalCtrl', ['$scope',
    function($scope) {
      $scope.helper.init();
      $scope.tplData = $scope.helper.tplData;
      $scope.onChooseDocument = function(fileId) {
        $scope.helper.onChooseDocument(fileId);
      };
    }]);
